import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { SettingsResponse } from "../types/api";

export const settingsApiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.DEV
      ? "https://localhost:7166/"
      : `https://${globalThis.location.host}/`,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");

      return headers;
    },
  }),
  tagTypes: ["Settings"],
  endpoints: (builder) => ({
    getSettings: builder.query<SettingsResponse, void>({
      query: () => "Settings",
      providesTags: ["Settings"],
    }),
  }),
});

export const { useGetSettingsQuery } = settingsApiSlice;
